import React from "react";
import get from "lodash/get";
import { SocialShare } from "@quintype/components";
import PropTypes from "prop-types";
import { StickySocialShareTemplate } from "./../sticky-social-share";
import { StoryHeader } from "../story-header";
import { AuthorDetails } from "../author-details";
import { StoryCardStack } from "../story-card-stack";
import { StoryTags } from "../story-tag";
import { MostPopular } from "../most-popular";
import { MetypeCommentWrapper } from "../../metype-comments";
import { ColombiaAdWrapper } from "../../colombia-story";
import { DfpAd } from "../../dfp-ad/";
import humanizeDate from "../../utils/time-format";
import { EngagementCount } from "../../basic/engagement-count";
import { GlideSlider } from "../../molecules/glide-slider";
import { DFPAdsHorizontal } from "../../dfp-ad-horizontal";
// import { ViqeoEmbed } from "../viqeo-embed";
import "./photo.m.css";

export class PhotoStoryTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      renderMetype: false,
      renderColombia: false,
      carouselIndex: 1
    };
    this.galleryItems = [];
  }
  componentDidMount() {
    this.galleryItems = this.getImagesFromCards();
    this.setState({
      renderMetype: true,
      totalItems: this.galleryItems.length
    });
  }

  getImagesFromCards() {
    return this.props.story.cards.reduce((accumulator, currentValue) => {
      const storyElements = currentValue["story-elements"];
      const imageElements = storyElements.filter(element => element.type === "image");
      accumulator = accumulator.concat(imageElements);
      return accumulator;
    }, []);
  }

  render() {
    const author = {
      name: get(this.props.story, ["authors", 0, "name"], this.props.story["author-name"]),
      id: get(this.props.story, ["authors", 0, "id"], this.props.story["author-id"]),
      twitter: get(this.props.story, ["authors", 0, "twitter-handle"]),
      avatarUrl: get(this.props.story, ["authors", 0, "avatar-url"]),
      slug: get(this.props.story, ["authors", 0, "slug"])
    };

    return (
      <div styleName="photostory">
        <div>
          <div styleName="photo-slider">
            {this.galleryItems.length > 0 && (
              <GlideSlider
                story={this.props.story}
                totalItems={this.state.totalItems}
                getImagesFromCards={this.galleryItems}
              />
            )}
          </div>
          <StoryHeader story={this.props.story} subTitleClass="heading-space" />
          <div styleName="story-body">
            <SocialShare
              template={StickySocialShareTemplate}
              title={this.props.story.headline}
              url={this.props.story.slug}
              color="#fff"
            />
            <div styleName="story-content">
              <div styleName="author-wrapper">
                <div>
                  <AuthorDetails
                    author={author}
                    storyFirstPublishedDate={this.props.story["first-published-at"]}
                    storyLastPublishedDate={this.props.story["last-published-at"]}
                  />
                </div>
                <EngagementCount storyId={this.props.story.id} />
              </div>
              <StoryCardStack story={this.props.story} />
              <StoryTags tags={this.props.story.tags} />
              <span>
                {this.props.story["first-published-at"] !== this.props.story["last-published-at"]
                  ? `Published: ${humanizeDate(this.props.story["first-published-at"])}`
                  : null}
              </span>
              {/* <ViqeoEmbed /> */}
            </div>
          </div>
          <DFPAdsHorizontal />
          {this.state.renderMetype && (
            <MetypeCommentWrapper metypeConfig={this.props.metypeConfig} story={this.props.story} />
          )}
          <ColombiaAdWrapper />
        </div>

        <div>
          <div styleName="dfp">
            <DfpAd adtype="NH_300x250" />
          </div>
          <MostPopular mostPopular={this.props.mostPopular} id={this.props.story.id} hideIcon />
          <div styleName="dfp">
            <DfpAd adtype="NH_MP_300x600" />
          </div>
        </div>
      </div>
    );
  }
}

function PhotoStory(props) {
  return (
    <div className="story-grid">
      <PhotoStoryTemplate story={props.story} mostPopular={props.mostPopular} metypeConfig={props.metypeConfig} />
    </div>
  );
}

export { PhotoStory };
PhotoStoryTemplate.propTypes = {
  mostPopular: PropTypes.Array,
  story: PropTypes.shape({
    "author-name": PropTypes.string,
    "author-id": PropTypes.number,
    headline: PropTypes.string,
    slug: PropTypes.string,
    "first-published-at": PropTypes.number,
    "last-published-at": PropTypes.number,
    cards: PropTypes.Array,
    tags: PropTypes.Array,
    id: PropTypes.string
  }),
  metypeConfig: PropTypes.object
};
PhotoStory.propTypes = {
  story: PropTypes.object,
  mostPopular: PropTypes.Array,
  metypeConfig: PropTypes.object
};
